var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "m-configs-merge" } },
    [
      _c("config-merge-popup", {
        ref: "config-merge-popup",
        on: { "show-c-diff-preview-popup": _vm.showDiffPreviewPopup },
      }),
      _c("configs-popup-edit-info", { ref: "configs-popup-edit-info" }),
      _c("c-edit-value-dialog", { ref: "c-edit-value-dialog" }),
      _c("c-diff-preview-popup", {
        ref: "c-diff-preview-popup",
        on: { "resolve-conflict": _vm.onResolveConflict },
      }),
      _c("c-import-config-popup", { ref: "c-import-config-popup" }),
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("c-l-table", {
                ref: "c-l-table",
                on: {
                  "show-config-merge-popup": _vm.showMergeAndDeployPopup,
                  "show-configs-popup-edit-info": _vm.showEditInfoPopup,
                  "show-c-edit-name": _vm.onEditName,
                  "show-c-edit-marker": _vm.onEditMarker,
                  "show-c-import-config-popup": _vm.showImportConfigPopup,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }